<template>
  <div
    class="flex min-h-screen items-center justify-center bg-background px-6 text-foreground"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="flex w-full max-w-sm flex-col items-center gap-4 text-center">
      <img
        :src="APP_CONFIG.brand.logoPath"
        :alt="APP_CONFIG.brand.name"
        class="h-24 w-auto max-w-full object-contain"
      />
      <div class="space-y-1">
        <p class="text-sm text-foreground">{{ APP_CONFIG.brand.subtitle }}</p>
        <p class="text-sm text-muted-foreground">{{ t('common.resourceLoadingDescription') }}</p>
      </div>
      <Loader2 class="h-7 w-7 animate-spin text-primary" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Loader2 } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';
import { APP_CONFIG } from '@/config/app-config';

const { t } = useI18n();
</script>
